import * as Color from 'color';

export const themeColorLevel = (color: Color, level: number) => {
    const base: Color = level > 0 ? Color.rgb(0, 0, 0) : Color.rgb(255, 255, 255);

    const absLevel = Math.abs(level);

    return base.mix(color, absLevel);
}